import { useState } from "react";
import { toast } from "./Toast";
import { setApprovalStatus } from "../api";
import "./ApprovalEmailDetail.css";

export default function ApprovalEmailDetail({ email, onActionComplete }) {
  const [mode, setMode] = useState(null); // "edit" | "reject" | null
  const [editedText, setEditedText] = useState("");
  const [rejectComment, setRejectComment] = useState("");
  const [loading, setLoading] = useState(false);

  if (!email) {
    return (
      <div className="approval-placeholder">
        აირჩიეთ წერილი სანახავად
      </div>
    );
  }

  const from = email.from_email || "";
  const to = Array.isArray(email.to_emails) ? email.to_emails.join(", ") : email.to_emails || "";
  const date = email.date_str || "";
  const subject = email.subject || "";
  const originalMessage = email.text_body || (email.html_body ? email.html_body.replace(/<[^>]*>/g, "") : "");
  const aiReply = email.reply?.final_reply_content || email.reply?.gpt_generated_reply || "";

  async function handleApprove() {
    if (!window.confirm("დარწმუნებული ხართ? პასუხი გაიგზავნება მეილით.")) return;
    setLoading(true);
    try {
      await setApprovalStatus(email.id, "approved");
      toast("პასუხი დამტკიცებულია და გაგზავნილია!", "success");
      onActionComplete?.();
    } catch (err) {
      toast("შეცდომა: " + err.message, "error");
    }
    setLoading(false);
  }

  async function handleEditAndSend() {
    if (!editedText.trim()) {
      toast("ტექსტი ცარიელია.", "warning");
      return;
    }
    if (!window.confirm("დარწმუნებული ხართ? რედაქტირებული პასუხი გაიგზავნება მეილით.")) return;
    setLoading(true);
    try {
      await setApprovalStatus(email.id, "approved", { editedContent: editedText });
      toast("პასუხი დარედაქტირდა და გაიგზავნა!", "success");
      setMode(null);
      onActionComplete?.();
    } catch (err) {
      toast("შეცდომა: " + err.message, "error");
    }
    setLoading(false);
  }

  async function handleReject() {
    if (!rejectComment.trim()) {
      toast("მიუთითეთ უარყოფის მიზეზი.", "warning");
      return;
    }
    setLoading(true);
    try {
      await setApprovalStatus(email.id, "draft", { rejectionComment: rejectComment });
      toast("პასუხი უარყოფილია და კომენტარით დაბრუნებულია.", "success");
      setMode(null);
      onActionComplete?.();
    } catch (err) {
      toast("შეცდომა: " + err.message, "error");
    }
    setLoading(false);
  }

  function openEditMode() {
    setEditedText(aiReply);
    setMode("edit");
  }

  return (
    <div className="approval-container">
      <h2 className="approval-subject">{subject}</h2>

      <div className="approval-meta">
        <div><strong>გამომგზავნი:</strong> {from}</div>
        <div><strong>მიმღები:</strong> {to}</div>
        <div><strong>თარიღი:</strong> {date}</div>
        <div><strong>დეპარტამენტი:</strong> {email.department_names?.length > 1
          ? email.department_names.join(", ")
          : email.department_name}</div>
      </div>

      <div className="approval-section">
        <h3 className="approval-title">ორიგინალი წერილი</h3>
        <div className="approval-box">{originalMessage}</div>
      </div>

      <div className="approval-section">
        <h3 className="approval-title">მომზადებული პასუხი</h3>
        <div className="approval-box">{aiReply}</div>
      </div>

      {/* Edit mode */}
      {mode === "edit" && (
        <div className="approval-section">
          <h3 className="approval-title">რედაქტირებული ვერსია</h3>
          <textarea
            className="approval-textarea"
            value={editedText}
            onChange={(e) => setEditedText(e.target.value)}
            rows={8}
          />
          <div className="approval-inline-actions">
            <button className="approve-btn" onClick={handleEditAndSend} disabled={loading}>
              გაგზავნა
            </button>
            <button className="cancel-action-btn" onClick={() => setMode(null)}>
              გაუქმება
            </button>
          </div>
        </div>
      )}

      {/* Reject mode */}
      {mode === "reject" && (
        <div className="approval-section">
          <h3 className="approval-title">უარყოფის მიზეზი</h3>
          <textarea
            className="approval-textarea"
            value={rejectComment}
            onChange={(e) => setRejectComment(e.target.value)}
            placeholder="მიუთითეთ რატომ უარყოფთ პასუხს..."
            rows={4}
          />
          <div className="approval-inline-actions">
            <button className="reject-btn" onClick={handleReject} disabled={loading}>
              უარყოფა
            </button>
            <button className="cancel-action-btn" onClick={() => setMode(null)}>
              გაუქმება
            </button>
          </div>
        </div>
      )}

      {/* Main actions - only show when not in a sub-mode */}
      {!mode && (
        <div className="approval-actions">
          <button className="approve-btn" onClick={handleApprove} disabled={loading}>
            დამტკიცება და გაგზავნა
          </button>
          <button className="edit-approve-btn" onClick={openEditMode} disabled={loading}>
            რედაქტირება და გაგზავნა
          </button>
          <button className="reject-btn" onClick={() => setMode("reject")} disabled={loading}>
            უარყოფა კომენტარით
          </button>
        </div>
      )}
    </div>
  );
}
